import axios from '@/lib/AxApi';

export default
{
  async selectExamRow(params, cb)
  {
    try
    {
      var response = await axios.get('/Exam/selectExamRow',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async selectMarkExamRow(params, cb)
  {
    try
    {
      var response = await axios.get('/Exam/selectMarkExamRow',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async selectSingleRow(params, cb)
  {
    try
    {
      var response = await axios.get('/Exam/selectSingleRow',
      {
        params: params
      })
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async insertExam(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/insertExam', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async calcProgress(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/calcProgress', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async marklExamAnswers(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/marklExamAnswers', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async updateRow(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/updateRow', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async insertExamAnswers(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/insertExamAnswers', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async resetChapter(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/resetChapter', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async resetBlock(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/resetBlock', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async resetAll(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/resetAll', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async resetAllByUser(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/resetAllByUser', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
  async resetChapeterByUser(params, cb)
  {
    try
    {
      var response = await axios.post('/Exam/resetChapeterByUser', params);
      return response.data;
    }
    catch (e)
    {
      throw (
      {
        error: true,
        notice: axios.errorHandler(e)
      })
    }
  },
}